// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__lXP0V","spin":"Loader_spin__JHNjz","container":"Loader_container__ihfLo"};